/**
 *  @function AldwynCrossStoreCheckout
 *  @description
 *  Khi người dùng bấm nút checkout (button[name="checkout"]) trên CỬA HÀNG HIỆN TẠI,
 *  script đọc giỏ hàng, tìm biến thể (variant) tương ứng trên cửa hàng ĐÍCH (aldwynco.com),
 *  rồi chuyển hướng sang cart permalink dạng https://aldwynco.com/cart/ID:QTY,ID:QTY.
 *
 *  Kiến trúc: MATCH TRƯỚC -> REDIRECT SAU. Nếu BẤT KỲ dòng nào không giải quyết được,
 *  HỦY toàn bộ redirect và để checkout gốc chạy bình thường (không redirect một phần).
 *
 *  Cả hai cửa hàng dùng CHUNG theme này, nên script tự phát hiện host lúc chạy và KHÔNG làm gì
 *  khi đang ở chính aldwynco.com (để checkout gốc chạy).
 *
 *  CÁCH NHÚNG (thêm vào cuối layout/theme.liquid, ngay trước </body>, dùng TAB như các dòng khác):
 *    <script src="{{ 'aldwyn-cross-store-checkout.js' | asset_url }}" defer="defer"></script>
 */

(function () {
  'use strict';

  // Chống gắn listener hai lần (nếu file bị nhúng trùng)
  if (window.__aldwynCrossStoreCheckout) return;
  window.__aldwynCrossStoreCheckout = true;

  /* =========================================================================
   * ====  CẤU HÌNH — CHỈNH TAY Ở ĐÂY  =======================================
   * =======================================================================*/

  // Bật log chi tiết ra console (info). Cảnh báo/lỗi luôn được in dù cờ này tắt.
  const DEBUG = false;

  // Tên miền cửa hàng ĐÍCH (nơi cart permalink trỏ tới). Đây là hằng số duy nhất
  // cần đổi nếu domain thay đổi. Không kèm https:// và không kèm dấu / cuối.
  const TARGET_DOMAIN = 'aldwynco.com';

  // Domain .myshopify.com của cửa hàng đích (nếu biết). Dùng để nhận diện chắc chắn
  // hơn khi đang xem qua preview/myshopify. Để trống nếu chưa biết.
  const TARGET_MYSHOPIFY = ''; // ví dụ: 'aldwynco.myshopify.com'

  // Các host được coi là "ĐANG Ở cửa hàng đích" -> script KHÔNG can thiệp, để checkout gốc chạy.
  // Đã tự động bao gồm TARGET_DOMAIN và biến thể www. Thêm domain staging/preview nếu có.
  const EXTRA_TARGET_HOSTS = [
    // 'staging.aldwynco.com',
    // 'aldwynco.myshopify.com',
  ];

  /**
   * ===== DANH SÁCH WEB (DOMAIN NGUỒN) ĐƯỢC PHÉP CHẠY FILE NÀY =====
   * Script CHỈ hoạt động khi web hiện tại nằm trong danh sách này. Ở domain khác -> không làm gì,
   * nút checkout chạy y như bình thường.
   *
   * VD: 'halosneaker.com' -> khớp https://halosneaker.com/products/comfort-orthopedic-shoes,
   *     và khớp cả www.halosneaker.com, shop.halosneaker.com (mọi subdomain).
   *     KHÔNG khớp halosneaker.com.abc.net (tránh domain giả mạo lợi dụng).
   *
   * Chỉ ghi TÊN MIỀN: không kèm https://, không kèm đường dẫn, không kèm dấu / cuối.
   * ĐỂ MẢNG RỖNG [] -> chạy trên MỌI domain (tắt kiểm tra này).
   *
   * LƯU Ý: KHÔNG cần thêm store đích (aldwynco.com) vào đây — nó được xử lý riêng qua TARGET_DOMAIN,
   * và phần "nhận" trên aldwynco vẫn luôn chạy dù danh sách này không có nó.
   */
  const ALLOWED_SOURCE_DOMAINS = [
    // 'halosneaker.com',
    // 'halosneaker.myshopify.com',   // thêm nếu test qua bản xem trước .myshopify.com
    // 'mot-web-khac.com',
  ];

  // Giới hạn thời gian cho mỗi request cross-origin (ms). Quá hạn -> coi như thất bại -> checkout gốc.
  const REQUEST_TIMEOUT_MS = 8000;

  // Thời gian sống của cache catalogue trong sessionStorage (ms).
  const CATALOGUE_TTL_MS = 10 * 60 * 1000; // 10 phút

  // Chặn quét vô hạn: 40 trang * 250 sp = tối đa 10.000 sản phẩm.
  const MAX_CATALOGUE_PAGES = 40;
  const PAGE_DELAY_MS = 200; // nghỉ giữa các trang để tránh bị throttle

  // Nếu true -> permalink có ?storefront=true (về trang GIỎ HÀNG). Mặc định false -> vào thẳng CHECKOUT.
  const GO_TO_CART_INSTEAD = false;

  // Giới hạn độ dài URL permalink (an toàn cho trình duyệt). Vượt ngưỡng -> checkout gốc.
  const MAX_URL_LENGTH = 2000;

  // PHƯƠNG ÁN DỰ PHÒNG khi KHÔNG fetch được cross-origin (CORS bị chặn / mạng lỗi):
  // thay vì bỏ về checkout gốc ngay, MÃ HÓA giỏ hàng vào URL rồi chuyển sang aldwynco,
  // để chính script này (chạy trên aldwynco) giải mã và khớp SAME-ORIGIN (luôn chạy được).
  // Đặt false nếu chỉ muốn dùng cross-origin thuần (CORS hỏng -> checkout gốc).
  const ENABLE_DATA_REDIRECT_FALLBACK = true;

  // Tên tham số URL mang dữ liệu giỏ hàng sang store đích (phần "nhận" đọc tham số này).
  const INCOMING_PARAM = 'aldwyn_xcart';

  // Trang "hạ cánh" trên store đích cho phương án dự phòng (nên nhẹ; script sẽ tự nhảy tiếp
  // sang /cart/ID:QTY sau khi khớp xong). '/cart' thường nhẹ và đúng ngữ cảnh.
  const RECEIVER_LANDING_PATH = '/cart';

  // CỔNG THỜI GIAN Ở TRÊN TRANG: khách phải Ở TRÊN TRANG HIỆN TẠI đủ số ms này thì mới đủ điều kiện
  // chạy cross-store. Bấm checkout SỚM hơn -> dùng CHECKOUT GỐC như thường.
  // Đếm lại từ đầu MỖI KHI tải/chuyển trang (đo theo trang hiện tại, không cộng dồn cả phiên).
  // 30000 = 30 giây. ĐỂ 0 nếu muốn TẮT điều kiện này.
  const MIN_TIME_ON_PAGE_MS = 10000;

  // CỔNG THỜI GIAN: script CHỈ chuyển hướng sang aldwynco khi CHỮ SỐ CUỐI của PHÚT hiện tại
  // nằm trong danh sách này. [0, 5] -> chỉ hoạt động ở các phút ...:00, :05, :10, :15, :20, ...
  // (tức phút chia hết cho 5). Ngoài các phút đó, khách bấm checkout sẽ dùng CHECKOUT GỐC như thường.
  // ĐỂ MẢNG RỖNG [] nếu muốn TẮT cổng thời gian (luôn hoạt động).
  // LƯU Ý: dùng đồng hồ LOCAL của trình duyệt khách; nếu máy khách sai giờ thì cổng cũng sai theo.
  const ACTIVE_MINUTE_LAST_DIGITS = [0];

  /* ===== ĐIỀU KIỆN LỚN NHẤT: CHẶN THEO QUỐC GIA CỦA IP =====================
   * IP thuộc các nước trong BLOCKED_COUNTRIES sẽ KHÔNG chạy cross-store (bấm checkout -> dùng
   * checkout gốc như thường). Đây là điều kiện được KIỂM TRA TRƯỚC mọi điều kiện khác (giờ giấc...).
   * Trình duyệt không tự biết quốc gia của IP nên script hỏi một dịch vụ định vị-theo-IP (có CORS).
   * ========================================================================*/

  // Bật/tắt toàn bộ tính năng chặn theo quốc gia.
  const GEO_BLOCK_ENABLED = true;

  // MÃ QUỐC GIA (ISO-2, viết hoa) bị chặn. VN=Việt Nam, HK=Hồng Kông, SG=Singapore.
  const BLOCKED_COUNTRIES = ['VN', 'HK', 'SG', 'JP', 'CN'];

  // Khi KHÔNG xác định được quốc gia (API lỗi/bị chặn/timeout):
  //  - false (mặc định — AN TOÀN cho điều kiện lớn nhất): KHÔNG chạy cross-store -> checkout gốc.
  //  - true: vẫn chạy cross-store dù chưa biết nước (chấp nhận rủi ro sót IP thuộc nước bị chặn).
  const PROCEED_IF_GEO_UNKNOWN = false;

  // Ép quốc gia để TEST (VD 'US' để giả lập khách NGOÀI vùng chặn; 'VN' để thử bị chặn).
  // Để trống '' khi chạy thật. LƯU Ý: nếu bạn đang ở VN, phải đặt 'US' (hoặc dùng VPN) mới test được redirect.
  const GEO_COUNTRY_OVERRIDE = '';

  // Thời gian chờ tối đa cho mỗi lần hỏi API định vị (ms).
  const GEO_LOOKUP_TIMEOUT_MS = 4000;

  /**
   * PRODUCT_MAP — ánh xạ THỦ CÔNG sản phẩm cửa hàng hiện tại -> handle trên aldwynco.com.
   * Vì tiêu đề/handle KHÁC nhau giữa hai store, hãy điền tay ở đây cho chắc chắn.
   *
   * Khóa (key): handle HOẶC tiêu đề sản phẩm ở CỬA HÀNG HIỆN TẠI (không phân biệt hoa/thường,
   *             dấu tiếng Việt, dấu câu — đều được chuẩn hóa khi so khớp).
   * Giá trị (value): HANDLE sản phẩm tương ứng trên aldwynco.com.
   *
   * Nếu một sản phẩm KHÔNG có trong map -> tự động dò theo tiêu đề đã chuẩn hóa trong catalogue đích.
   */
  const PRODUCT_MAP = {
    // ---- Ví dụ (đã điền mẫu — hãy thay bằng dữ liệu thật, hoặc xóa đi) ----
    // 'ao-thun-basic': 'basic-tee',           // khớp theo handle store hiện tại
    // 'Áo Thun Basic Nam':  'basic-tee',       // hoặc khớp theo tiêu đề
    // 'giay-sneaker-classic': 'classic-sneaker',
    'anti-choking-emergency-rescue-kit': 'getinhalux-anti-choking-emergency-rescue-kit-1',
    // 'casual-sports-loafers-for-men': 'casual-sports-loafers-for-men-1'
  };

  /**
   * OPTION_NAME_MAP — ánh xạ TÊN option cửa hàng hiện tại -> tên option trên aldwynco.com.
   * Ví dụ store hiện tại gọi "Colour"/"Màu sắc" còn aldwynco gọi "Color".
   */
  const OPTION_NAME_MAP = {
    // 'Colour':   'Color',
    // 'Màu sắc':  'Color',
    // 'Kích cỡ':  'Size',
  };

  /**
   * OPTION_VALUE_MAP — ánh xạ GIÁ TRỊ option (áp dụng cho MỌI option) cửa hàng hiện tại -> aldwynco.com.
   * Ví dụ "Small" -> "S", "Đen" -> "Black".
   */
  const OPTION_VALUE_MAP = {
    // 'Small':  'S',
    // 'Medium': 'M',
    // 'Large':  'L',
    // 'Đen':    'Black',
    // 'Trắng':  'White',
  };

  /* =========================================================================
   * ====  HẾT PHẦN CẤU HÌNH — bên dưới là logic  ============================
   * =======================================================================*/

  const TARGET_BASE = 'https://' + TARGET_DOMAIN;
  const CHECKOUT_SELECTOR = 'button[name="checkout"]';
  const SESSION_KEY = 'aldwyn_catalogue_cache_v1';
  const GEO_SESSION_KEY = 'aldwyn_geo_country_v1';
  const BYPASS_ATTR = 'aldwynBypass'; // dataset key: đánh dấu lần submit "bỏ qua interceptor"

  // Danh sách nước bị chặn đã chuẩn hóa (ISO-2 viết hoa) để so khớp nhanh.
  const NORM_BLOCKED_COUNTRIES = (Array.isArray(BLOCKED_COUNTRIES) ? BLOCKED_COUNTRIES : [])
    .map((c) => String(c).trim().toUpperCase());

  // Số lần thử tối đa cho MỖI trang catalogue khi bị throttle (429/430) trước khi bỏ cuộc.
  const MAX_THROTTLE_RETRIES = 3;

  // Cache trong bộ nhớ (sống theo vòng đời trang)
  const productCache = new Map(); // handle -> product | null
  let catalogueMemo = null;       // mảng sản phẩm (đã rút gọn) | null
  let inFlight = false;           // cờ chống double-click

  // ---- Log ----------------------------------------------------------------
  const log = (level, ...args) => {
    const prefix = '[aldwyn-xstore]';
    if (level === 'error') { console.error(prefix, ...args); return; }
    if (level === 'warn') { console.warn(prefix, ...args); return; }
    if (DEBUG) console.info(prefix, ...args);
  };

  // ---- Tiện ích -----------------------------------------------------------
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // Chuẩn hóa chuỗi để so khớp: thường hóa, bỏ dấu tiếng Việt, bỏ dấu câu, gộp khoảng trắng.
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    return String(str)
      .toLowerCase()
      .replace(/đ/g, 'd')               // 'đ' không tách được bằng NFD -> xử lý riêng
      .normalize('NFD')                 // tách ký tự + dấu
      .replace(/[̀-ͯ]/g, '')  // bỏ dấu (diacritics)
      .replace(/[^a-z0-9]+/g, ' ')      // bỏ dấu câu -> khoảng trắng
      .trim()
      .replace(/\s+/g, ' ');            // gộp nhiều khoảng trắng
  };

  // Dựng bản map với KHÓA đã chuẩn hóa (để tra cứu không phụ thuộc hoa/thường/dấu).
  const buildNormalizedMap = (map) => {
    const out = {};
    for (const key in map) {
      if (Object.prototype.hasOwnProperty.call(map, key)) {
        out[normalize(key)] = map[key];
      }
    }
    return out;
  };

  const NORM_PRODUCT_MAP = buildNormalizedMap(PRODUCT_MAP);
  const NORM_OPTION_NAME_MAP = buildNormalizedMap(OPTION_NAME_MAP);
  const NORM_OPTION_VALUE_MAP = buildNormalizedMap(OPTION_VALUE_MAP);

  // Áp map tên/giá trị option (trả về giá trị đích thô; caller sẽ normalize khi so khớp).
  const applyNameMap = (name) => {
    const mapped = NORM_OPTION_NAME_MAP[normalize(name)];
    return mapped !== undefined ? mapped : name;
  };
  const applyValueMap = (value) => {
    const mapped = NORM_OPTION_VALUE_MAP[normalize(value)];
    return mapped !== undefined ? mapped : value;
  };

  // ---- Nhận diện cửa hàng -------------------------------------------------
  // Trả về true nếu ĐANG CHẠY trên chính cửa hàng đích -> khi đó KHÔNG can thiệp.
  const isTargetStore = () => {
    const host = (location.hostname || '').toLowerCase().replace(/^www\./, '');
    if (host === TARGET_DOMAIN) return true;
    if (TARGET_MYSHOPIFY && host === TARGET_MYSHOPIFY.toLowerCase()) return true;

    // Shopify.shop (permanent domain) được Shopify tiêm vào runtime qua content_for_header.
    try {
      if (TARGET_MYSHOPIFY && window.Shopify && Shopify.shop &&
        String(Shopify.shop).toLowerCase() === TARGET_MYSHOPIFY.toLowerCase()) {
        return true;
      }
    } catch (e) { /* bỏ qua */ }

    for (let i = 0; i < EXTRA_TARGET_HOSTS.length; i++) {
      const h = String(EXTRA_TARGET_HOSTS[i]).toLowerCase().replace(/^www\./, '');
      if (host === h) return true;
    }
    return false;
  };

  // true nếu web HIỆN TẠI nằm trong danh sách domain nguồn được phép chạy script.
  // Khớp CHÍNH XÁC domain hoặc là SUBDOMAIN của nó:
  //   'halosneaker.com' -> khớp halosneaker.com, www.halosneaker.com, shop.halosneaker.com
  //                     -> KHÔNG khớp halosneaker.com.abc.net (dùng endsWith('.' + domain), không
  //                        dùng "chứa chuỗi", để domain giả mạo không lọt).
  // Mảng rỗng -> cho phép mọi domain (tắt kiểm tra).
  const isAllowedSourceHost = () => {
    if (!Array.isArray(ALLOWED_SOURCE_DOMAINS) || ALLOWED_SOURCE_DOMAINS.length === 0) return true;
    const host = (location.hostname || '').toLowerCase();
    for (let i = 0; i < ALLOWED_SOURCE_DOMAINS.length; i++) {
      // Bỏ 'www.' ở cấu hình để viết 'www.halosneaker.com' hay 'halosneaker.com' đều được.
      const d = String(ALLOWED_SOURCE_DOMAINS[i]).trim().toLowerCase().replace(/^www\./, '');
      if (!d) continue;
      if (host === d || host.endsWith('.' + d)) return true;
    }
    return false;
  };

  // ---- fetch có timeout (bao trùm CẢ lúc đọc body) ------------------------
  // Timer sống xuyên suốt cả việc đọc body (res.json()), nên một response đã gửi
  // xong header nhưng TREO giữa chừng body cũng bị abort -> reject -> về checkout gốc.
  // Trả về { status, ok, headers, data } — data là JSON đã phân tích (chỉ khi ok).
  const fetchWithTimeout = async (url, options) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
    try {
      const res = await fetch(url, Object.assign({ signal: controller.signal }, options || {}));
      const data = res.ok ? await res.json() : null; // đọc body TRONG phạm vi còn timer
      return { status: res.status, ok: res.ok, headers: res.headers, data: data };
    } finally {
      clearTimeout(timer);
    }
  };

  // ---- Đọc giỏ hàng hiện tại (same-origin -> luôn an toàn CORS) -----------
  // Đi qua fetchWithTimeout để /cart.js treo cũng bị abort -> reject -> về checkout gốc.
  const fetchCurrentCart = async () => {
    const res = await fetchWithTimeout('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('/cart.js -> ' + res.status);
    return res.data;
  };

  // ---- Lấy sản phẩm đích theo handle: /products/HANDLE.json --------------
  // LƯU Ý: dùng .json (public storefront feed, CÓ CORS: Access-Control-Allow-Origin: *)
  // CHỨ KHÔNG dùng .js (Ajax API — không mở CORS cross-origin một cách đáng tin cậy).
  // - 404  -> trả null (không tìm thấy; caller sẽ thử chiến lược khác).
  // - throw (CORS/mạng) -> ném lên trên -> HỦY redirect, dùng checkout gốc (quyết định 4).
  const fetchProductByHandle = async (handle) => {
    if (!handle) return null;
    if (productCache.has(handle)) return productCache.get(handle);

    const url = TARGET_BASE + '/products/' + encodeURIComponent(handle) + '.json';
    const res = await fetchWithTimeout(url, { headers: { Accept: 'application/json' } });
    if (res.status === 404) { productCache.set(handle, null); return null; }
    if (!res.ok) throw new Error('products/' + handle + '.json -> ' + res.status);

    const data = res.data;
    const product = data && data.product ? data.product : null;
    productCache.set(handle, product);
    return product;
  };

  // Rút gọn sản phẩm về đúng các trường cần cho khớp biến thể (tiết kiệm bộ nhớ/sessionStorage).
  const extractOptionNames = (product) => {
    const opts = product && product.options;
    if (!Array.isArray(opts)) return [];
    // product.options có thể là mảng object {name,...} (feed .json) hoặc mảng string.
    return opts.map((o) => (o && typeof o === 'object' ? o.name : o));
  };

  const trimProduct = (p) => ({
    handle: p.handle,
    title: p.title,
    options: extractOptionNames(p),
    variants: (Array.isArray(p.variants) ? p.variants : []).map((v) => ({
      id: v.id,
      option1: v.option1 !== undefined ? v.option1 : null,
      option2: v.option2 !== undefined ? v.option2 : null,
      option3: v.option3 !== undefined ? v.option3 : null,
      available: v.available,
    })),
  });

  // ---- Quét toàn bộ catalogue đích (public feed /products.json, page-until-empty) ----
  const pullCatalogue = async () => {
    const all = [];
    for (let page = 1; page <= MAX_CATALOGUE_PAGES; page++) {
      const url = TARGET_BASE + '/products.json?limit=250&page=' + page;

      // Tải 1 trang, có GIỚI HẠN số lần thử lại khi bị throttle (429/430) để KHÔNG treo checkout.
      let data = null;
      for (let attempts = 1; ; attempts++) {
        const res = await fetchWithTimeout(url, { headers: { Accept: 'application/json' } });

        if (res.status === 429 || res.status === 430) { // bị throttle
          if (attempts >= MAX_THROTTLE_RETRIES) {
            // Hết lượt thử -> NÉM lỗi để .catch() ở interceptor về checkout gốc (không lặp vô hạn).
            throw new Error('products.json page ' + page + ' bị throttle (' + res.status +
              ') sau ' + attempts + ' lần thử');
          }
          // Retry-After KHÔNG phải header CORS-safelisted -> thường null cross-origin (=> 2s).
          // Kẹp trần thời gian chờ để một giá trị lớn cũng không làm treo checkout.
          const retry = Math.min((Number(res.headers.get('Retry-After')) || 2) * 1000, 3000);
          await delay(retry);
          continue; // thử lại CHÍNH trang này (có giới hạn)
        }
        if (!res.ok) throw new Error('products.json page ' + page + ' -> ' + res.status);

        data = res.data;
        break; // tải trang thành công -> thoát vòng thử lại
      }

      const products = data && Array.isArray(data.products) ? data.products : [];
      if (products.length === 0) break;            // mảng rỗng = hết catalogue
      for (let i = 0; i < products.length; i++) all.push(trimProduct(products[i]));
      if (products.length < 250) break;            // trang cuối (chưa đầy)
      await delay(PAGE_DELAY_MS);
    }
    return all;
  };

  // Lấy catalogue với cache: bộ nhớ -> sessionStorage (TTL) -> tải mới.
  const getCatalogue = async () => {
    if (catalogueMemo) return catalogueMemo;

    try {
      const raw = sessionStorage.getItem(SESSION_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && Array.isArray(parsed.products) &&
          (Date.now() - parsed.t) < CATALOGUE_TTL_MS) {
          catalogueMemo = parsed.products;
          log('info', 'Dùng catalogue từ sessionStorage:', catalogueMemo.length, 'sản phẩm');
          return catalogueMemo;
        }
      }
    } catch (e) { /* sessionStorage hỏng/không có -> bỏ qua */ }

    log('info', 'Đang tải catalogue từ', TARGET_BASE);
    const products = await pullCatalogue();
    catalogueMemo = products;
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify({ t: Date.now(), products }));
    } catch (e) { /* vượt quota -> chỉ dùng cache bộ nhớ */ }
    log('info', 'Đã tải catalogue:', products.length, 'sản phẩm');
    return products;
  };

  // ---- Khớp biến thể ------------------------------------------------------
  const isAvailable = (variant) => variant && variant.available !== false;

  // Lấy các cặp {name,value} đã chuẩn hóa + đã áp map từ 1 line item của /cart.js.
  const extractCartPairs = (item) => {
    const owv = Array.isArray(item.options_with_values) ? item.options_with_values : [];
    return owv.map((o) => ({
      name: normalize(applyNameMap(o.name)),
      value: normalize(applyValueMap(o.value)),
    }));
  };

  // Sản phẩm chỉ có 1 biến thể ("Default Title") -> không có option để so khớp.
  const isDefaultOnly = (cartPairs) =>
    cartPairs.length === 0 ||
    (cartPairs.length === 1 && cartPairs[0].name === 'title' && cartPairs[0].value === 'default title');

  // Với sản phẩm default-only: chọn biến thể available DUY NHẤT; nếu mơ hồ -> null.
  const pickForDefault = (variants) => {
    if (variants.length === 1) return isAvailable(variants[0]) ? variants[0] : null;
    const avail = variants.filter(isAvailable);
    if (avail.length === 1) return avail[0];
    return null; // nhiều lựa chọn -> không đoán
  };

  // (a) Khớp theo TÊN option: yêu cầu cùng tập tên option và MỌI giá trị trùng.
  // Nếu sản phẩm đích có số option KHÁC -> tập tên khác nhau -> không khớp (an toàn).
  const variantMatchesByName = (variant, targetOptionNames, cartPairs) => {
    const targetMap = {};
    for (let i = 0; i < targetOptionNames.length; i++) {
      const val = variant['option' + (i + 1)];
      if (val === null || val === undefined) continue;
      targetMap[normalize(targetOptionNames[i])] = normalize(val);
    }
    const targetKeys = Object.keys(targetMap);
    if (targetKeys.length !== cartPairs.length) return false;      // khác số option -> bỏ
    return cartPairs.every((pair) => targetMap[pair.name] === pair.value);
  };

  // Trả về biến thể đích khớp + còn hàng, hoặc null (hết hàng / không khớp).
  // GHI CHÚ: /products.json chỉ cho biết boolean `available`, KHÔNG có số tồn kho, nên
  // "số lượng > tồn kho" không thể kiểm tra trước; ta chỉ yêu cầu available !== false,
  // còn checkout mới là nguồn sự thật cuối cùng.
  //
  // CHỈ khớp theo TÊN option (sau khi áp OPTION_NAME_MAP). KHÔNG có fallback theo VỊ TRÍ:
  // hai store có thể khai báo option theo THỨ TỰ khác nhau, nên khớp theo index dễ chọn
  // NHẦM biến thể (vd Left/Right đảo chỗ, kích thước đối xứng). Không căn được theo tên
  // -> trả null để HỦY redirect và dùng checkout gốc (fail-safe), thay vì đoán theo vị trí.
  const matchVariant = (product, item) => {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    if (variants.length === 0) return null;

    const cartPairs = extractCartPairs(item);
    if (isDefaultOnly(cartPairs)) return pickForDefault(variants);

    const targetOptionNames = extractOptionNames(product);

    const byName = variants.find((v) => variantMatchesByName(v, targetOptionNames, cartPairs));
    if (byName) return isAvailable(byName) ? byName : null;

    return null;
  };

  // ---- Giải quyết 1 line item -> variant id trên cửa hàng đích -----------

  // Những line item KHÔNG thể tái tạo qua cart permalink -> phải HỦY (quyết định 4):
  //  - subscription/selling plan (permalink không mang selling_plan),
  //  - thuộc tính tùy chỉnh do người dùng nhập (engraving/upload/quà tặng...).
  const isPermalinkSafe = (item) => {
    if (item.selling_plan_allocation) {
      log('warn', 'Line item có selling plan (subscription) — không thể mang qua permalink:', item.title);
      return false;
    }
    if (item.properties) {
      const custom = Object.keys(item.properties).filter((k) => k.charAt(0) !== '_');
      if (custom.length > 0) {
        log('warn', 'Line item có thuộc tính tùy chỉnh — không thể mang qua permalink:', item.title, custom);
        return false;
      }
    }
    return true;
  };

  // Thử khớp biến thể trong MỘT sản phẩm. Trả { product, variant } nếu khớp + còn hàng, else null.
  const matchInProduct = (product, item) => {
    const variant = matchVariant(product, item);
    return variant ? { product: product, variant: variant } : null;
  };

  // Giải quyết 1 line item -> variant id trên store đích.
  // Chiến lược (ưu tiên từ trên xuống):
  //  (1) PRODUCT_MAP: đã map tay -> DÙNG ĐÚNG sản phẩm đó (authoritative). Không khớp biến thể -> hủy.
  //  (2) ĐƯỜNG NHANH: đoán theo handle; nếu handle + tiêu đề + BIẾN THỂ đều khớp -> dùng luôn
  //      (khỏi tải cả catalogue). Đây là trường hợp phổ biến nhất.
  //  (3) QUÉT nhiều sản phẩm cùng tiêu đề: khi (2) có sản phẩm nhưng biến thể KHÔNG khớp (rất có thể
  //      sản phẩm đúng là một sản phẩm KHÁC cùng tên, vd aldwynco có 'anti-choking-emergency' VÀ
  //      'anti-choking-emergency-1'), duyệt MỌI sản phẩm cùng tiêu đề trong catalogue và chọn cái
  //      DUY NHẤT có biến thể khớp. 0 khớp -> hủy; >= 2 khớp -> MƠ HỒ -> hủy (tránh mua nhầm).
  const resolveLineItem = async (item) => {
    if (!isPermalinkSafe(item)) return null;

    // (1) PRODUCT_MAP — ưu tiên cao nhất, dùng đúng sản phẩm đã map.
    const mappedHandle = NORM_PRODUCT_MAP[normalize(item.handle)] ||
      NORM_PRODUCT_MAP[normalize(item.product_title)] || null;
    if (mappedHandle) {
      log('info', 'PRODUCT_MAP:', (item.handle || item.product_title), '->', mappedHandle);
      const product = await fetchProductByHandle(mappedHandle); // throw (CORS) -> hủy; 404 -> null
      if (!product) { log('warn', 'PRODUCT_MAP trỏ tới handle không tồn tại:', mappedHandle); return null; }
      const m = matchInProduct(product, item);
      if (!m) { log('warn', 'Sản phẩm map được nhưng KHÔNG khớp biến thể:', item.product_title); return null; }
      return m.variant.id;
    }

    // (2) Đường nhanh: đoán theo handle. Handle + tiêu đề + biến thể đều khớp -> dùng luôn.
    if (item.handle) {
      const guess = await fetchProductByHandle(item.handle); // 404 -> null; CORS -> throw -> hủy toàn bộ
      if (guess && normalize(guess.title) === normalize(item.product_title)) {
        const m = matchInProduct(guess, item);
        if (m) return m.variant.id;
        // Handle + tiêu đề khớp nhưng biến thể KHÔNG khớp -> sản phẩm đúng có thể là 1 sản phẩm KHÁC
        // cùng tiêu đề -> rơi xuống bước quét bên dưới.
        log('info', 'Handle+tiêu đề khớp nhưng biến thể không khớp -> quét các sản phẩm cùng tiêu đề');
      }
    }

    // (3) Quét CÁC sản phẩm cùng tiêu đề. DUYỆT lần lượt, DỪNG NGAY ở sản phẩm ĐẦU TIÊN có biến thể
    //     khớp -> checkout sản phẩm đó (không quét tiếp). Nếu không cái nào khớp -> hủy (checkout gốc).
    const catalogue = await getCatalogue();
    const target = normalize(item.product_title);
    const sameTitle = target ? catalogue.filter((p) => normalize(p.title) === target) : [];
    if (sameTitle.length === 0) {
      log('warn', 'Không tìm thấy sản phẩm cùng tiêu đề trên ' + TARGET_DOMAIN + ':',
        item.product_title, '(handle:', item.handle + ')');
      return null;
    }

    for (let i = 0; i < sameTitle.length; i++) {
      const m = matchInProduct(sameTitle[i], item);
      if (m) {
        log('info', 'Sản phẩm cùng tiêu đề đầu tiên có biến thể khớp -> checkout:', m.product.handle);
        return m.variant.id; // DỪNG ngay tại sản phẩm đầu tiên khớp
      }
    }

    log('warn', 'Có ' + sameTitle.length + ' sản phẩm cùng tiêu đề nhưng KHÔNG cái nào khớp biến thể:',
      item.product_title, item.options_with_values);
    return null;
  };

  // ---- Dựng permalink -----------------------------------------------------
  // Giữ NGUYÊN dấu ':' và ',' (không percent-encode) đúng ngữ pháp cart permalink.
  const buildPermalink = (resolved) => {
    const path = resolved.map((r) => r.variantId + ':' + r.quantity).join(',');
    let url = TARGET_BASE + '/cart/' + path;
    if (GO_TO_CART_INSTEAD) url += '?storefront=true';
    return url;
  };

  // ---- Mã hóa/giải mã giỏ hàng cho phương án dự phòng (redirect-kèm-data) --
  // Base64url trên chuỗi UTF-8 (dùng TextEncoder/TextDecoder) -> an toàn với tiếng Việt,
  // gọn hơn encodeURIComponent cho ký tự có dấu, và an toàn khi đặt trong query string.
  const toBase64Url = (bytes) => {
    let bin = '';
    for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  };
  const fromBase64Url = (str) => {
    const b64 = str.replace(/-/g, '+').replace(/_/g, '/');
    const bin = atob(b64);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return bytes;
  };

  // Chỉ mang những trường tối thiểu để store đích khớp lại: tiêu đề, handle, số lượng, các option.
  const encodeCartPayload = (items) => {
    const payload = items.map((it) => ({
      t: it.product_title,
      h: it.handle,
      // Hòa giải số lượng đang chờ trên DOM (giống đường permalink chính ở resolved.push
      // dùng resolveQuantity), để chỉnh sửa số lượng chưa kịp POST (debounce 300ms) KHÔNG bị
      // mất trên đường dự phòng. resolveQuantity tự lùi về it.quantity khi không có input khớp.
      q: resolveQuantity(it),
      o: (Array.isArray(it.options_with_values) ? it.options_with_values : [])
        .map((o) => [o.name, o.value]),
    }));
    const json = JSON.stringify(payload);
    return toBase64Url(new TextEncoder().encode(json));
  };

  // Giải mã -> mảng "pseudo line item" có ĐÚNG hình dạng mà resolveLineItem cần.
  const decodeCartPayload = (param) => {
    const json = new TextDecoder().decode(fromBase64Url(param));
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) throw new Error('payload không phải mảng');
    return arr.map((it) => ({
      product_title: it.t,
      handle: it.h,
      quantity: it.q,
      options_with_values: (Array.isArray(it.o) ? it.o : [])
        .map((pair) => ({ name: pair[0], value: pair[1] })),
    }));
  };

  // Store nguồn: KHÔNG tới được store đích (CORS/mạng) -> mã hóa cart, chuyển sang store đích.
  // Trả về true nếu đã điều hướng (đang rời trang), false nếu không dùng được (caller về checkout gốc).
  const redirectWithCartData = (cart) => {
    if (!ENABLE_DATA_REDIRECT_FALLBACK) return false;
    try {
      const encoded = encodeCartPayload(cart.items);
      const sep = RECEIVER_LANDING_PATH.indexOf('?') === -1 ? '?' : '&';
      const url = TARGET_BASE + RECEIVER_LANDING_PATH + sep + INCOMING_PARAM + '=' + encoded;
      if (url.length > MAX_URL_LENGTH) {
        log('warn', 'URL dự phòng quá dài (' + url.length + ') -> checkout gốc');
        return false;
      }
      log('info', 'Không fetch được cross-origin -> chuyển kèm dữ liệu sang', TARGET_BASE);
      window.location.assign(url);
      return true;
    } catch (e) {
      log('error', 'Lỗi khi tạo redirect-kèm-data -> checkout gốc:', e);
      return false;
    }
  };

  // ---- Trạng thái nút (animation loading GỐC của theme) ------------------
  // Spinner SVG GỐC của theme (snippet 'thb-loading' trong svg-icons.liquid). Nút checkout gốc chỉ
  // có <span>text</span>, chưa có phần spinner; ta chèn span.loading-overlay này vào để khi thêm
  // class 'loading' nút hiện ĐÚNG animation spinner như các nút khác (Add to cart...). Không overlay
  // toàn màn hình, không chữ "Checking out..." — chỉ animation bình thường của nút.
  const SPINNER_SVG = '<svg aria-hidden="true" focusable="false" role="presentation" ' +
    'class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
    '<circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';

  // ---- fallback checkout gốc ----------------------------------------------

  // Hiển thị trạng thái bận (KHÔNG disable thật: nút vẫn cần dùng làm submitter cho requestSubmit).
  const setBusy = (button, busy) => {
    try {
      if (busy) {
        // Chèn spinner GỐC của theme vào nút (chỉ 1 lần) để hiện đúng animation loading như thường.
        if (!button.querySelector('.loading-overlay')) {
          const ov = document.createElement('span');
          ov.className = 'loading-overlay';
          ov.innerHTML = SPINNER_SVG;
          button.appendChild(ov);
        }
        button.setAttribute('aria-busy', 'true');
        button.classList.add('loading');
      } else {
        button.removeAttribute('aria-busy');
        button.classList.remove('loading');
      }
    } catch (e) { /* bỏ qua lỗi DOM */ }
  };

  // Để checkout GỐC chạy sau khi ta đã preventDefault. Phải KÍCH HOẠT LẠI submit thủ công.
  const fallbackToNativeCheckout = (button) => {
    inFlight = false;
    setBusy(button, false); // gỡ trạng thái loading khỏi nút

    // button.form giải quyết được CẢ form bao ngoài (drawer) LẪN liên kết qua form="cart-form" (trang cart).
    const form = button.form;

    // Vì sao requestSubmit(button) THAY VÌ form.submit():
    //  - requestSubmit(submitter) GỬI KÈM name/value của nút submit (name="checkout") — đây chính là
    //    tín hiệu để Shopify chuyển sang trang checkout. form.submit() KHÔNG kèm submitter nên mất
    //    "checkout" và chỉ cập nhật giỏ, KHÔNG vào checkout.
    //  - requestSubmit phát sự kiện 'submit' (không phải 'click'), còn interceptor của ta nghe 'click',
    //    nên KHÔNG bị tái nhập -> không lặp vô hạn.
    if (form && typeof form.requestSubmit === 'function') {
      try {
        button.dataset[BYPASS_ATTR] = 'true'; // chốt chặn thêm, phòng trường hợp re-dispatch click
        form.requestSubmit(button);
        setTimeout(() => { try { delete button.dataset[BYPASS_ATTR]; } catch (e) { } }, 0);
        return;
      } catch (e) {
        log('warn', 'requestSubmit(button) lỗi, thử click gốc:', e);
      }
    }

    // Phương án cuối: phát lại click gốc với cờ bypass để interceptor BỎ QUA (không lặp).
    try {
      button.dataset[BYPASS_ATTR] = 'true';
      button.click();
      setTimeout(() => { try { delete button.dataset[BYPASS_ATTR]; } catch (e) { } }, 0);
    } catch (e) {
      log('error', 'Không thể fallback về checkout gốc:', e);
    }
  };

  // ---- Số lượng thực tế (hòa giải chỉnh sửa đang chờ trên trang /cart) -----
  // Nút +/- và ô nhập số lượng chỉ POST lên server SAU khi debounce 300ms, nên /cart.js
  // có thể trả số lượng CŨ nếu người dùng vừa chỉnh rồi bấm checkout ngay. Ưu tiên đọc
  // giá trị đang hiển thị trong input updates[] tương ứng (giống checkout gốc submit
  // #cart-form với đúng số lượng vừa nhập). Không có/không hợp lệ -> dùng /cart.js.
  const resolveQuantity = (item) => {
    try {
      if (item && item.key) {
        const wantedId = 'updates_' + item.key;
        const inputs = document.querySelectorAll('input[name="updates[]"]');
        let picked = null;
        for (let i = 0; i < inputs.length; i++) {
          if (inputs[i].id !== wantedId) continue; // so khớp id trong JS -> khỏi escape ':' của key
          picked = inputs[i];
          if (inputs[i].offsetParent !== null) break; // ưu tiên input đang HIỂN THỊ (mobile/desktop)
        }
        if (picked) {
          const domQty = parseInt(picked.value, 10);
          if (Number.isFinite(domQty) && domQty > 0) return domQty;
        }
      }
    } catch (e) { /* bỏ qua lỗi DOM -> dùng số lượng từ /cart.js */ }
    return item.quantity;
  };

  // ---- Luồng chính --------------------------------------------------------
  const handleCheckout = async (button) => {
    // ĐIỀU KIỆN LỚN NHẤT: chốt lại quốc gia (AWAIT nếu lúc bấm chưa tra xong).
    // IP thuộc nước bị chặn — hoặc không xác định được (khi PROCEED_IF_GEO_UNKNOWN=false) -> checkout gốc.
    if (GEO_BLOCK_ENABLED) {
      const country = await getVisitorCountry();
      if (!isGeoAllowed(country)) {
        log('info', 'IP thuộc nước bị chặn/không xác định (' + country + ') -> checkout gốc');
        return fallbackToNativeCheckout(button);
      }
    }

    const cart = await fetchCurrentCart();

    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      log('warn', 'Giỏ hàng trống -> dùng checkout gốc');
      return fallbackToNativeCheckout(button);
    }

    // Có dòng KHÔNG thể mang qua permalink (subscription / thuộc tính tùy chỉnh)? -> checkout gốc luôn,
    // không thử cross-store (và cũng không đẩy sang store đích rồi kẹt ở đó).
    for (let i = 0; i < cart.items.length; i++) {
      if (!isPermalinkSafe(cart.items[i])) {
        log('warn', 'Giỏ có dòng không thể mang qua permalink -> checkout gốc:', cart.items[i].title);
        return fallbackToNativeCheckout(button);
      }
    }

    // Giải quyết TỪNG dòng. Chỉ cần MỘT dòng thất bại -> HỦY toàn bộ (không redirect một phần).
    const resolved = [];
    for (let i = 0; i < cart.items.length; i++) {
      const item = cart.items[i];
      let variantId;
      try {
        variantId = await resolveLineItem(item);
      } catch (err) {
        // Phân loại lỗi. CHỈ khi fetch bị REJECT thật sự — mạng hỏng / CORS chặn, trình duyệt ném
        // TypeError — mới coi là "KHÔNG tiếp cận được" store đích và thử redirect-kèm-data (vì chỉ
        // same-origin trên store đích mới khớp lại được — đây là đúng ý đồ CORS/mạng ở phần cấu hình).
        // MỌI lỗi CÒN LẠI — HTTP 4xx/5xx đọc được, throttle 429/430 hết lượt thử, body 200 KHÔNG phải
        // JSON (trang mật khẩu/bảo trì/challenge), hay timeout/abort — đều CHỨNG TỎ store đích VẪN
        // phản hồi được (server/IP-based, không phải do origin). Redirect sang đó chỉ gặp lại đúng lỗi
        // đó khi khớp same-origin và kẹt khách ở trang giỏ RỖNG. -> về checkout gốc trên store nguồn.
        if (err instanceof TypeError) {
          log('warn', 'Không tiếp cận được ' + TARGET_DOMAIN + ' (CORS/mạng):', err);
          if (redirectWithCartData(cart)) return; // đã điều hướng đi
          return fallbackToNativeCheckout(button); // dự phòng tắt/không dùng được -> checkout gốc
        }
        log('warn', 'Store đích phản hồi nhưng lỗi (HTTP/parse/timeout), không phải CORS/mạng ' +
          '-> checkout gốc:', err);
        return fallbackToNativeCheckout(button);
      }
      if (!variantId) {
        // Tới được store đích nhưng KHÔNG khớp sản phẩm/biến thể -> checkout gốc (quyết định 4).
        // Dự phòng redirect-kèm-data cũng vô ích vì dùng chung dữ liệu -> không thử.
        log('warn', 'Có dòng không giải quyết được -> HỦY redirect, dùng checkout gốc:', item.title);
        return fallbackToNativeCheckout(button);
      }
      resolved.push({ variantId: variantId, quantity: resolveQuantity(item) });
    }

    const permalink = buildPermalink(resolved);
    if (permalink.length > MAX_URL_LENGTH) {
      log('warn', 'Permalink quá dài (' + permalink.length + ' ký tự) -> dùng checkout gốc');
      return fallbackToNativeCheckout(button);
    }

    log('info', 'Chuyển hướng cross-store tới:', permalink);
    // Không reset inFlight ở đây: trang sắp điều hướng đi.
    window.location.assign(permalink);
  };

  // ---- Phía "NHẬN" (chạy khi script này ở CHÍNH store đích aldwynco) -------
  // Khi store nguồn dùng phương án dự phòng, nó chuyển sang aldwynco kèm tham số cart đã mã hóa.
  // Ở đây (same-origin) ta giải mã, khớp lại rồi nhảy tới /cart/ID:QTY. Mọi thất bại -> Ở LẠI trang
  // hiện tại (không điều hướng ép buộc), tránh vòng lặp. Chỉ điều hướng KHI đã khớp trọn vẹn.
  const handleIncomingCart = async (param) => {
    try {
      // ĐIỀU KIỆN LỚN NHẤT cũng áp dụng ở phía nhận (phòng thủ): IP bị chặn -> không xử lý, ở lại trang.
      if (GEO_BLOCK_ENABLED && !isGeoAllowed(await getVisitorCountry())) {
        log('info', 'IP thuộc nước bị chặn -> không xử lý cart nhận vào');
        return;
      }

      const items = decodeCartPayload(param);
      if (!items.length) { log('warn', 'Dữ liệu cart rỗng từ store nguồn'); return; }

      const resolved = [];
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (!isPermalinkSafe(item)) {
          log('warn', 'Dòng không port được (nhận):', item.product_title);
          return;
        }
        // resolveLineItem gọi fetch tới TARGET_BASE == chính origin này -> SAME-ORIGIN, không dính CORS.
        const variantId = await resolveLineItem(item);
        if (!variantId) {
          log('warn', 'Không khớp trên store đích (nhận) -> ở lại trang, không redirect:', item.product_title);
          return;
        }
        // Ở phía nhận không có form /cart để đọc số lượng "đang chờ" -> dùng luôn số lượng đã mã hóa.
        const qty = (Number.isFinite(item.quantity) && item.quantity > 0) ? item.quantity : 1;
        resolved.push({ variantId: variantId, quantity: qty });
      }

      const permalink = buildPermalink(resolved);
      if (permalink.length > MAX_URL_LENGTH) {
        log('warn', 'Permalink (nhận) quá dài -> ở lại trang');
        return;
      }
      log('info', 'Nhận cart từ store nguồn, chuyển tới:', permalink);
      window.location.assign(permalink);
    } catch (e) {
      // Tham số hỏng/không giải mã được -> im lặng ở lại trang (đang ở aldwynco, vẫn mua sắm bình thường).
      log('warn', 'Không giải mã được dữ liệu cart nhận vào -> bỏ qua:', e);
    }
  };

  // ---- Tìm checkbox điều khoản chưa tick gần nút checkout ------------------
  // Vì listener của ta chạy ở pha CAPTURE (trước các handler điều khoản chạy ở pha bubble),
  // ta phải TỰ kiểm tra: nếu có checkbox điều khoản và CHƯA tick -> KHÔNG can thiệp,
  // để handler điều khoản gốc chạy và chặn checkout.
  const findUncheckedTerms = (button) => {
    let node = button.parentElement;
    while (node && node !== document.body) {
      const cb = node.querySelector('input[type="checkbox"][id^="CartTerms"]');
      if (cb) return cb.checked ? null : cb;
      node = node.parentElement;
    }
    return null;
  };

  // ---- ĐIỀU KIỆN LỚN NHẤT: xác định & chặn quốc gia theo IP --------------
  // Các endpoint định vị-theo-IP (miễn phí, có CORS, không cần key). Thử lần lượt tới khi có kết quả.
  const GEO_ENDPOINTS = [
    { url: 'https://get.geojs.io/v1/ip/country.json', field: 'country' },
    { url: 'https://ipwho.is/', field: 'country_code' },
    { url: 'https://ipapi.co/json/', field: 'country_code' },
  ];

  let visitorCountry = undefined; // undefined=chưa tra xong; null=tra thất bại; 'VN'/'US'...=đã biết
  let countryPromise = null;      // single-flight: chỉ tra 1 lần mỗi phiên

  const lookupCountryFromNetwork = async () => {
    for (let i = 0; i < GEO_ENDPOINTS.length; i++) {
      const ep = GEO_ENDPOINTS[i];
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), GEO_LOOKUP_TIMEOUT_MS);
      try {
        const res = await fetch(ep.url, { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (res.ok) {
          const data = await res.json();
          const code = data && data[ep.field];
          if (code && typeof code === 'string') return code.trim().toUpperCase();
        }
      } catch (e) {
        /* endpoint lỗi/timeout -> thử endpoint kế tiếp */
      } finally {
        clearTimeout(timer);
      }
    }
    return null; // tất cả endpoint đều thất bại
  };

  // Tra quốc gia MỘT LẦN mỗi phiên (single-flight + cache sessionStorage). Gán vào visitorCountry.
  const resolveVisitorCountry = () => {
    if (countryPromise) return countryPromise;
    countryPromise = (async () => {
      if (GEO_COUNTRY_OVERRIDE) { // ép để test
        visitorCountry = String(GEO_COUNTRY_OVERRIDE).trim().toUpperCase();
        return visitorCountry;
      }
      try {
        const cached = sessionStorage.getItem(GEO_SESSION_KEY);
        if (cached) { visitorCountry = cached; return visitorCountry; } // chỉ cache khi tra THÀNH CÔNG
      } catch (e) { /* sessionStorage lỗi -> tra mạng */ }

      const code = await lookupCountryFromNetwork();
      visitorCountry = code;
      // CHỈ lưu cache khi có mã quốc gia hợp lệ. Thất bại (null) KHÔNG cache -> trang sau sẽ thử lại,
      // tránh việc 1 lần lỗi mạng tạm thời khóa fail-closed suốt cả phiên.
      if (code) { try { sessionStorage.setItem(GEO_SESSION_KEY, code); } catch (e) { /* bỏ qua */ } }
      return code;
    })();
    return countryPromise;
  };

  const getVisitorCountry = () => resolveVisitorCountry();

  // true nếu ĐƯỢC PHÉP chạy cross-store theo quốc gia. country: 'VN' | null | undefined | ''
  const isGeoAllowed = (country) => {
    if (!GEO_BLOCK_ENABLED) return true;
    if (!country) return PROCEED_IF_GEO_UNKNOWN;        // null/undefined/'' = không xác định được
    return NORM_BLOCKED_COUNTRIES.indexOf(country) === -1;
  };

  // ---- Cổng thời gian Ở TRÊN TRANG ---------------------------------------
  // Dùng performance.now() (đồng hồ ĐƠN ĐIỆU, tính từ lúc bắt đầu tải trang) nếu có, để việc đo
  // KHÔNG bị sai khi máy khách chỉnh giờ hệ thống. Không có thì lùi về Date.now().
  const nowMs = () => (typeof performance !== 'undefined' && typeof performance.now === 'function')
    ? performance.now()
    : Date.now();

  // Mốc khách BẮT ĐẦU ở trang này: gán 1 lần lúc script chạy (mỗi lần tải/chuyển trang là mốc mới).
  const pageEnteredAt = nowMs();

  // true nếu khách đã ở trên trang hiện tại ĐỦ LÂU (>= MIN_TIME_ON_PAGE_MS). 0 -> luôn cho phép.
  const hasStayedLongEnough = () => {
    if (!MIN_TIME_ON_PAGE_MS || MIN_TIME_ON_PAGE_MS <= 0) return true;
    return (nowMs() - pageEnteredAt) >= MIN_TIME_ON_PAGE_MS;
  };

  // Số giây đã ở trên trang (chỉ để ghi log cho dễ theo dõi).
  const secondsOnPage = () => Math.round((nowMs() - pageEnteredAt) / 100) / 10;

  // ---- Cổng thời gian -----------------------------------------------------
  // true nếu ĐƯỢC PHÉP chuyển hướng cross-store ở thời điểm hiện tại: chữ số cuối của phút
  // (getMinutes() % 10) phải nằm trong ACTIVE_MINUTE_LAST_DIGITS. Mảng rỗng -> luôn cho phép.
  // Kiểm tra tại THỜI ĐIỂM BẤM (không phải lúc tải trang) để bám sát phút thực tế.
  const isWithinActiveWindow = () => {
    if (!Array.isArray(ACTIVE_MINUTE_LAST_DIGITS) || ACTIVE_MINUTE_LAST_DIGITS.length === 0) return true;
    const lastDigit = new Date().getMinutes() % 10;
    return ACTIVE_MINUTE_LAST_DIGITS.indexOf(lastDigit) !== -1;
  };

  // ---- Interceptor (document, pha CAPTURE) --------------------------------
  const onDocumentClickCapture = (event) => {
    let button = null;
    try {
      const el = event.target;
      if (!el || typeof el.closest !== 'function') return;

      button = el.closest(CHECKOUT_SELECTOR);
      if (!button) return;

      // Lần submit "bypass" do chính ta kích hoạt -> để đi qua bình thường (không lặp).
      if (button.dataset[BYPASS_ATTR] === 'true') return;

      // ĐIỀU KIỆN LỚN NHẤT (kiểm tra ĐẦU TIÊN): chặn theo quốc gia IP.
      // Nếu ĐÃ biết quốc gia (đã preload xong) và không được phép -> KHÔNG can thiệp, để checkout gốc chạy.
      // Nếu CHƯA tra xong (visitorCountry === undefined) -> để lọt xuống dưới; handleCheckout sẽ AWAIT
      // kết quả geo và quay về checkout gốc nếu bị chặn (nên không bao giờ redirect nhầm IP bị chặn).
      if (GEO_BLOCK_ENABLED && visitorCountry !== undefined && !isGeoAllowed(visitorCountry)) {
        log('info', 'IP thuộc nước bị chặn (' + visitorCountry + ') -> dùng checkout gốc');
        return;
      }

      // CỔNG "Ở TRÊN TRANG ĐỦ LÂU": chưa đủ MIN_TIME_ON_PAGE_MS -> KHÔNG can thiệp, để checkout gốc chạy.
      if (!hasStayedLongEnough()) {
        log('info', 'Mới ở trên trang ' + secondsOnPage() + 's (cần ' + (MIN_TIME_ON_PAGE_MS / 1000) +
          's) -> dùng checkout gốc');
        return;
      }

      // CỔNG THỜI GIAN: ngoài khung phút cho phép (đuôi 0/5) -> KHÔNG can thiệp gì cả,
      // để checkout GỐC (kể cả kiểm tra điều khoản) chạy hoàn toàn bình thường.
      if (!isWithinActiveWindow()) {
        log('info', 'Ngoài khung phút cho phép (đuôi ' + ACTIVE_MINUTE_LAST_DIGITS.join('/') +
          ') -> dùng checkout gốc');
        return;
      }

      // Có điều khoản chưa tick -> nhường handler gốc (không preventDefault, để event bubble tiếp).
      if (findUncheckedTerms(button)) {
        log('info', 'Checkbox điều khoản chưa tick -> nhường handler gốc');
        return;
      }

      // Chặn submit mặc định (đủ để dừng), rồi làm việc bất đồng bộ.
      event.preventDefault();
      event.stopPropagation();

      if (inFlight) { // chống double-click: nuốt click thừa trong lúc đang xử lý
        log('info', 'Đang xử lý, bỏ qua click lặp');
        return;
      }
      inFlight = true;
      setBusy(button, true); // nút chạy animation loading gốc của theme trong lúc xử lý

      handleCheckout(button).catch((err) => {
        // Bất kỳ lỗi nào (CORS/mạng/không mong đợi) -> KHÔNG để kẹt nút; về checkout gốc.
        log('error', 'Lỗi khi xử lý cross-store checkout -> checkout gốc:', err);
        fallbackToNativeCheckout(button);
      });
    } catch (err) {
      // Phòng thủ tuyệt đối: không bao giờ để người dùng kẹt ở nút chết.
      log('error', 'Lỗi bất ngờ trong interceptor -> checkout gốc:', err);
      try { if (button) fallbackToNativeCheckout(button); } catch (e) { /* bỏ qua */ }
    }
  };

  // ---- Khởi tạo -----------------------------------------------------------
  // Nếu đang ở CHÍNH cửa hàng đích -> KHÔNG gắn interceptor checkout.
  // NHƯNG nếu có dữ liệu cart do store nguồn chuyển sang (phương án dự phòng) thì xử lý phần "nhận".
  if (isTargetStore()) {
    let incoming = null;
    try { incoming = new URLSearchParams(location.search).get(INCOMING_PARAM); } catch (e) { /* bỏ qua */ }
    if (ENABLE_DATA_REDIRECT_FALLBACK && incoming) {
      log('info', 'Ở store đích, nhận dữ liệu cart từ store nguồn -> đang khớp same-origin');
      handleIncomingCart(incoming);
    } else {
      log('info', 'Đang ở cửa hàng đích (' + location.hostname + ') -> bỏ qua, dùng checkout gốc');
    }
    return;
  }

  // Web hiện tại có nằm trong danh sách domain nguồn được phép không? Không -> KHÔNG gắn gì cả,
  // nút checkout chạy y như bình thường. (Kiểm tra SAU isTargetStore để phần "nhận" trên store đích
  // vẫn luôn hoạt động dù aldwynco.com không có trong ALLOWED_SOURCE_DOMAINS.)
  if (!isAllowedSourceHost()) {
    log('info', 'Domain hiện tại (' + location.hostname + ') KHÔNG có trong ALLOWED_SOURCE_DOMAINS ' +
      '-> bỏ qua, dùng checkout gốc');
    return;
  }

  // ĐIỀU KIỆN LỚN NHẤT: preload quốc gia NGAY khi tải trang, để lúc khách bấm checkout đã có sẵn
  // kết quả (không phải chờ). Chạy 1 lần mỗi phiên (single-flight + cache sessionStorage).
  if (GEO_BLOCK_ENABLED) resolveVisitorCountry();

  // Pha CAPTURE (true) để bắt được nút ở CẢ cart drawer (bị re-render động) LẪN trang /cart,
  // đồng thời tự nhường handler điều khoản như trên.
  document.addEventListener('click', onDocumentClickCapture, true);
  log('info', 'Cross-store checkout đã kích hoạt. Đích:', TARGET_BASE);
})();
